import { HttpHeaders } from '@angular/common/http';

export const defaultHttpOptions = {
  headers: new HttpHeaders({
    ContentType: 'application/json',
  }),
};
